import { render, staticRenderFns } from "./ProcedureResult.vue?vue&type=template&id=461c7f70&scoped=true"
import script from "./ProcedureResult.vue?vue&type=script&lang=js"
export * from "./ProcedureResult.vue?vue&type=script&lang=js"
import style0 from "./ProcedureResult.vue?vue&type=style&index=0&id=461c7f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c7f70",
  null
  
)

export default component.exports